import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {AllInterCompanyFields, InterCompanyField} from '@enum/client/inter-company-field';
import {AllUserAreaFilters} from '@enum/user-area/user-area-filter';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {AllUserAreaColumns} from '@enum/user-area/user-area-column';
import {CrmSection} from '@enum/crm-section';

class AreaManagerPermissionClass implements UserPermission {
  readonly userRole = UserRole.AREA_MANAGER;
  readonly labelRole = 'Area Manager';
  readonly isAuthenticated = true;

  readonly canRequestEto = true;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = true;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = true;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = true;
  readonly canSeeAlternativeExternalCustomersTab = true;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = true;
  readonly crmSectionsVisible = [CrmSection.VerifiedContact, CrmSection.CustomerList, CrmSection.SalesTasks, CrmSection.Orders, CrmSection.Messages, CrmSection.Claims, CrmSection.Report, CrmSection.Preferences];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = AllInterCompanyFields;
  readonly editableInterCompanyDependentFields = [InterCompanyField.SHOWROOM, InterCompanyField.AGENCY];

  readonly visibleUserAreaFilters = AllUserAreaFilters;
  readonly visibleUserAreaColumns = AllUserAreaColumns;

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = true;
  readonly canDownloadPackingList = true;
  readonly canSeeConfigurationList = true;
  readonly canSeeCustomerConfigurationTab = true;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const AreaManagerPermission = new AreaManagerPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(AreaManagerPermission);
